import { LOAD_SYNC_BLOCKS, TOGGLE_SYNC_BLOCK } from "./actions";

const initialState = {
  data: [],
  loading: false,
  errorMessage: ""
};

const syncBlocks = (state = initialState, action) => {
  switch (action.type) {
    case LOAD_SYNC_BLOCKS.REQUEST:
      return { ...state, loading: true, errorMessage: "" };

    case LOAD_SYNC_BLOCKS.SUCCESS:
      return { ...state, loading: false, data: action.payload.data.data };

    case LOAD_SYNC_BLOCKS.FAILURE:
      return { ...state, loading: false, errorMessage: action.payload.error };

    case TOGGLE_SYNC_BLOCK.REQUEST:
      return { ...state, loading: true };

    case TOGGLE_SYNC_BLOCK.SUCCESS: {
      const { branch_id, is_blocked } = action.payload.data;
      const updated = state.data.map(item =>
        item.branch_id === branch_id ? { ...item, is_blocked } : item
      );
      return { ...state, loading: false, data: updated };
    }

    case TOGGLE_SYNC_BLOCK.FAILURE:
      return { ...state, loading: false, errorMessage: action.payload.error };

    default:
      return state;
  }
};

export { syncBlocks };
